import React from "react";

interface CardGradientProps {
  className?: string;
  width?: string | number;
  height?: string | number;
  fill?: string
}

const CrossCloseIcon: React.FC<CardGradientProps> = ({
  className,
  width = "21",
  height = "21",
  fill = "black"
}) => {
  return (
    <svg
    width={width}
    height={height}
    className={className}
      viewBox="0 0 21 21"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_1789_9854"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="21"
        height="21"
      >
        <rect x="0.5" y="0.5" width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1789_9854)">
        <path
          d="M10.499 12.0436L6.60402 15.9383C6.39638 16.1461 6.13916 16.25 5.83236 16.25C5.52555 16.25 5.26833 16.1461 5.06069 15.9383C4.85291 15.7307 4.74902 15.4735 4.74902 15.1667C4.74902 14.8599 4.85291 14.6027 5.06069 14.395L8.95548 10.5L5.06069 6.60501C4.85291 6.39738 4.74902 6.14015 4.74902 5.83335C4.74902 5.52654 4.85291 5.26932 5.06069 5.06168C5.26833 4.8539 5.52555 4.75002 5.83236 4.75002C6.13916 4.75002 6.39638 4.8539 6.60402 5.06168L10.499 8.95647L14.394 5.06168C14.6017 4.8539 14.8589 4.75002 15.1657 4.75002C15.4725 4.75002 15.7297 4.8539 15.9374 5.06168C16.1451 5.26932 16.249 5.52654 16.249 5.83335C16.249 6.14015 16.1451 6.39738 15.9374 6.60501L12.0426 10.5L15.9374 14.395C16.1451 14.6027 16.249 14.8599 16.249 15.1667C16.249 15.4735 16.1451 15.7307 15.9374 15.9383C15.7297 16.1461 15.4725 16.25 15.1657 16.25C14.8589 16.25 14.6017 16.1461 14.394 15.9383L10.499 12.0436Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};

export default CrossCloseIcon;
